module.exports = __webpack_public_path__ + "static/img/about-certificate-03.ce1431a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-03.jpg
// module id = K3RE
// module chunks = 1